import { IApiHints } from "../../types";

/**
 * 當語言選項更新時，同步提示詞資料
 * 過濾掉不在新語言選項中的提示詞
 *
 * @param currentHints - 當前的提示詞資料
 * @param newLanguageOptions - 新的語言選項列表
 * @returns 同步後的提示詞資料，如果沒有有效資料則返回 undefined
 */
export const syncHintsWithLanguages = (
    currentHints: IApiHints | undefined,
    newLanguageOptions: string[]
): IApiHints | undefined => {
    if (!currentHints || !Array.isArray(currentHints) || currentHints.length === 0) {
        return currentHints;
    }

    const syncedHints = currentHints.filter((hint) => newLanguageOptions.includes(hint.language));

    return syncedHints.length > 0 ? syncedHints : undefined;
};
